"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.US_PHONE_HELPER_CONFIG = void 0;
exports.US_PHONE_HELPER_CONFIG = {
    validationRegex: /^([2-9*][\d*]{2})[\d*]{3}[\d*]{4}$/,
    countryCode: '1',
    phoneMask: '(###) ###-####',
    obfuscateMask: '(***) ***-####',
};
//# sourceMappingURL=USConfig.js.map